import { Box, Typography, Stack } from '@mui/material';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BlockIcon from '@mui/icons-material/Block';
import { useAppSelector } from '../../../app/hooks';
import { selectSettings } from '../../settings/settingsSlice';

const texts = {
    title: {
        pl: 'Zakończ proces bez rejestracji',
        en: 'Finish process without registration',
        de: 'Vorgang ohne Registrierung abschließen',
    },
    items: [
        {
            type: 'positive',
            pl: 'Potwierdzenie na maila',
            en: 'Email confirmation',
            de: 'Bestätigung per E-Mail',
        },
        {
            type: 'negative',
            pl: 'Brak możliwości kontynuacji procesu w systemie',
            en: 'No possibility to continue the process in the system',
            de: 'Der Vorgang kann im System nicht fortgesetzt werden',
        },
        {
            type: 'negative',
            pl: 'Brak dostępu do dokumentu',
            en: 'No access to the document',
            de: 'Kein Zugriff auf das Dokument',
        },
    ],
};

export const NoRegistrationBox = () => {
    const { locale } = useAppSelector(selectSettings);
    const lang = locale === 'en-US' ? 'en' : locale;

    return (
        <>
            <Box display="flex" alignItems="center" mb={1}>
                <NoAccountsIcon sx={{ color: 'info.main', mr: 1 }} />
                <Typography variant="subtitle1" fontWeight="bold">
                    {texts.title[lang]}
                </Typography>
            </Box>

            <Stack spacing={0.5}>
                {texts.items.map((item, index) => (
                    <Box key={index} display="flex" alignItems="center">
                        {item.type === 'positive' ? (
                            <CheckCircleIcon fontSize="small" sx={{ color: 'success.main', mr: 1 }} />
                        ) : (
                            <BlockIcon fontSize="small" sx={{ color: 'error.main', mr: 1 }} />
                        )}
                        <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                            {item[lang]}
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </>
    );
};
